import React from "react";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import ButtonLoader from "../../../elements/ButtonLoader";

const ConfirmDelete = (props) => {
  const { loading, onHide, confirmDelete } = props;
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="buy_modal"
    >
      <Modal.Body>
        <div className="modal_inner_main position-relative">
          <div className="modal_buy-cont">
            <h4 className="fw-sbold m-0">Confirm delete</h4>
            <hr class="custom_hr"></hr>
            <div className="pt-2">
              <p className="fw-sbold ">Are you sure to delete ?</p>
              <div className="modal_buy_btn d-flex justify-content-end">
                <Button
                  className="mod_cancelbtn blackBtn border-0"
                  style={{ marginRight: "16px" }}
                  onClick={() => onHide()}
                >
                  Cancel
                </Button>
                {loading ? (
                  <Button
                    className="mod_confirmbtn blackBtn border-0"
                    style={{ minWidth: "100px" }}
                  >
                    <ButtonLoader color={"text-ligth"} />
                  </Button>
                ) : (
                  <Button
                    className="mod_confirmbtn blackBtn border-0"
                    onClick={confirmDelete}
                  >
                    Confirm
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmDelete;
